import React from 'react';

const Health = () => {
    return <>
    <h2>I am fine :D</h2>
    </>
}

export default Health;
